export const API_GW_URL="https://api.pettrak.kynetec.com"
export const CLIENT_ID="554df912-1a24-4160-aa51-68f63702e3b0"
export const ENVIRONMENT="prod"
